import {createApi} from '@reduxjs/toolkit/dist/query/react'
import {baseQueryWithReauth} from './BaseQueryReauth'
import {ICDRUserList, DataCDR, IRequestCDRData, ICDRUser, ICDRLine, ICDRLineList} from '../modules/cdr/core/_models'

interface ListResponse<T> {
  data: T[]
  total: number
}

export const cdrAPI = createApi({
  reducerPath: 'cdrAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['cdr', 'cdrUsers', 'cdrLines'],
  endpoints: (build) => ({
    dataFetch: build.query<ListResponse<DataCDR>, IRequestCDRData>({
      query: ({id, filter, account_id}) => ({
        method: 'POST',
        url: `/extensions/cdr/${id}`,
        params: account_id ? {account_id} : {},
        body: filter,
      }),
    }),
    getUsers: build.query<ICDRUserList, string>({
      query: (app_id) => ({
        url: `/extensions/cdr/${app_id}/users`,
      }),
      providesTags: (result, error, id) => [{type: 'cdrUsers' as const, id}],
    }),
    upsertUser: build.mutation<void, {app_id: string; user: ICDRUser[]}>({
      query: ({app_id, user}) => ({
        method: 'POST',
        url: `/extensions/cdr/${app_id}/users`,
        body: user,
      }),
      invalidatesTags: (result, error, {app_id}) => [{type: 'cdrUsers' as const, id: app_id}],
    }),
    deleteUser: build.mutation<void, {app_id: string; user_ids: string[]}>({
      query: ({app_id, user_ids}) => ({
        method: 'DELETE',
        url: `/extensions/cdr/${app_id}/users`,
        body: user_ids,
      }),
      invalidatesTags: ['cdrUsers'],
    }),
    getLines: build.query<ICDRLineList, string>({
      query: (app_id) => ({
        url: `/extensions/cdr/${app_id}/lines`,
      }),
      providesTags: (result, error, id) => [{type: 'cdrLines' as const, id}],
    }),
    upsertLines: build.mutation<void, {app_id: string; lines: ICDRLine[]}>({
      query: ({app_id, lines}) => ({
        method: 'POST',
        url: `/extensions/cdr/${app_id}/lines`,
        body: lines,
      }),
      invalidatesTags: (result, error, {app_id}) => [{type: 'cdrLines' as const, id: app_id}],
    }),
    deleteLine: build.mutation<void, {app_id: string; line_ids: string[]}>({
      query: ({app_id, line_ids}) => ({
        method: 'DELETE',
        url: `/extensions/cdr/${app_id}/lines`,
        body: line_ids,
      }),
      invalidatesTags: ['cdrLines'],
    }),
    getRecordingBlob: build.query<Blob, string>({
      query: (call_id) => ({
        url: `/extensions/cdr/${call_id}/record`,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
})
